.top-row-section-left {
    width: 50%;
    display: flex;
}

.top-row-section-right {
    gap: 8px;
    width: 48%;
    justify-content: flex-start;
    display: flex;
}

.host-name {
    width: 30%;
    justify-content: flex-start;
    flex-shrink: 0;
    display: flex;
}
